import { render, staticRenderFns } from "./fishqcInfo.vue?vue&type=template&id=8865c240&scoped=true&"
import script from "./fishqcInfo.vue?vue&type=script&lang=js&"
export * from "./fishqcInfo.vue?vue&type=script&lang=js&"
import style0 from "./fishqcInfo.vue?vue&type=style&index=0&id=8865c240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8865c240",
  null
  
)

export default component.exports